import { BlockControls, useBlockProps } from '@wordpress/block-editor';
import { useEffect, useState } from 'react';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, RangeControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import Filters from './components/Filters';
import StarRating from './components/Rating';
import TypographyControls from '../../components/typography';
import Color from '../../components/color';

const Edit = ({ attributes, setAttributes }) => {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { columns } = attributes;
    const { ProductPerPage } = attributes;
    const { starSize } = attributes;

    // get Product Data
    useEffect(() => {
        const fetchProducts = async () => {
            setIsLoading(true);

            fetch(
                `${EASYCOMMERCE.rest_base}/products?per_page=${ProductPerPage}`
            )
                .then((res) => res.json())
                .then((data) => {
                    setIsLoading(false);
                    setProducts(data.data.products);
                });
        };

        fetchProducts();
    }, [ProductPerPage]);

    const placeholderImage = `${EASYCOMMERCE.assets}/public/img/product/shop-product-placeholder.png`;

    return (
        <>
            <InspectorControls>
                <PanelBody title="Product Settings">
                    <RangeControl
                        label="Products Per Page"
                        value={ProductPerPage}
                        onChange={(value) =>
                            setAttributes({ ProductPerPage: value })
                        }
                        min={1}
                        max={20}
                    />
                </PanelBody>
                <PanelBody title="Grid Settings">
                    <RangeControl
                        label="Number of Columns"
                        value={columns}
                        onChange={(value) => setAttributes({ columns: value })}
                        min={1}
                        max={6}
                    />
                </PanelBody>

                <PanelBody
                    initialOpen={false}
                    title={__('Product Category', 'codesigner')}
                >
                    <Color
                        attributes={attributes}
                        attributeName="categoryColor"
                        setAttributes={setAttributes}
                        title="Color"
                    />
                    <TypographyControls
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attributeNames={[
                            'categoryFontSize',
                            'categoryFontWeight',
                            'categoryTextTransform',
                            'categoryStyle',
                            'categoryDecoration',
                            'categoryLineHeight',
                            'categorySpacing',
                        ]}
                    />
                </PanelBody>
                <PanelBody
                    initialOpen={false}
                    title={__('Product Title', 'codesigner')}
                >
                    <Color
                        attributes={attributes}
                        attributeName="titleColor"
                        setAttributes={setAttributes}
                        title="Color"
                    />
                    <TypographyControls
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attributeNames={[
                            'titleFontSize',
                            'titleFontWeight',
                            'titleTextTransfrom',
                            'titleStyle',
                            'titleDecoration',
                            'titleLineHeight',
                            'titleSpacing',
                        ]}
                    />
                </PanelBody>
                <PanelBody
                    initialOpen={false}
                    title={__('Product Rating', 'codesigner')}
                >
                    <RangeControl
                        label="Star Size"
                        value={starSize}
                        onChange={(value) => setAttributes({ starSize: value })}
                        min={1}
                        max={100}
                    />
                    <Color
                        attributes={attributes}
                        attributeName="ratingColor"
                        setAttributes={setAttributes}
                        title="Color"
                    />
                    <TypographyControls
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attributeNames={[
                            'ratingFontSize',
                            'ratingFontWeight',
                            'ratingTextTransform',
                            'ratingStyle',
                            'ratingDecoration',
                            'ratingLineHeight',
                            'ratingSpacing',
                        ]}
                    />
                </PanelBody>
                <PanelBody
                    initialOpen={false}
                    title={__('Product Price', 'codesigner')}
                >
                    <Color
                        attributes={attributes}
                        attributeName="priceColor"
                        setAttributes={setAttributes}
                        title="Color"
                    />
                    <TypographyControls
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attributeNames={[
                            'priceFontSize',
                            'priceFontWeight',
                            'priceTextTransform',
                            'priceStyle',
                            'priceDecoration',
                            'priceLineHeight',
                            'priceSpacing',
                        ]}
                    />
                </PanelBody>
                <PanelBody
                    initialOpen={false}
                    title={__('Cart Button', 'codesigner')}
                >
                    <Color
                        attributes={attributes}
                        attributeName="cartButtonColor"
                        setAttributes={setAttributes}
                        title="Color"
                    />
                    <Color
                        attributes={attributes}
                        attributeName="cartButtonBgColor"
                        setAttributes={setAttributes}
                        title="Color"
                    />
                    <TypographyControls
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attributeNames={[
                            'cartButtonFontSize',
                            'cartButtonFontWeight',
                            'cartButtonTextTransform',
                            'cartButtonStyle',
                            'cartButtonDecoration',
                            'cartButtonLineHeight',
                            'cartButtonSpacing',
                        ]}
                    />
                </PanelBody>
            </InspectorControls>
            {/* Block content start from here  */}
            <div {...useBlockProps()}>
                <div className="flex items-start justify-between gap-8">
                    <Filters />
                    <div className="!w-[calc(100%_-_340px)] easycommerce-shop-container">
                        {!isLoading &&
                            (products && products.length > 0 ? (
                                <div
                                    className={`grid grid-cols-${columns} gap-6`}
                                >
                                    {products.map((product, index) => (
                                        <div
                                            key={index}
                                            className="mb-6 border border-ec-border rounded-xl"
                                        >
                                            <div className="w-full flex items-center justify-center rounded-t-xl p-3">
                                                <img
                                                    src={
                                                        product.thumbnail.url
                                                            ? product.thumbnail
                                                                  .url
                                                            : placeholderImage
                                                    }
                                                    alt={product.title}
                                                    className="border rounded-t-xl easycommerce-thumbnail-img"
                                                />
                                            </div>
                                            <div className="p-4">
                                                {product.categories &&
                                                    product.categories.length >
                                                        0 && (
                                                        <div
                                                            className="text-[12px] mb-[8px]"
                                                            style={{
                                                                color:
                                                                    attributes.categoryColor ||
                                                                    'var(--color-ec-secondary)',
                                                                fontSize:
                                                                    attributes.categoryFontSize
                                                                        ? `${attributes.categoryFontSize}px`
                                                                        : '12px',
                                                                fontWeight:
                                                                    attributes.categoryFontWeight ||
                                                                    '500',
                                                                textTransform:
                                                                    attributes.categoryTextTransform ||
                                                                    'none',
                                                                fontStyle:
                                                                    attributes.categoryStyle ||
                                                                    'normal',
                                                                textDecoration:
                                                                    attributes.categoryDecoration ||
                                                                    'none',
                                                                lineHeight:
                                                                    attributes.categoryLineHeight
                                                                        ? `${attributes.categoryLineHeight}px`
                                                                        : '20px',
                                                                letterSpacing:
                                                                    attributes.categorySpacing
                                                                        ? `${attributes.categorySpacing}px`
                                                                        : '0px',
                                                            }}
                                                        >
                                                            {
                                                                product
                                                                    .categories[0]
                                                                    .name
                                                            }
                                                        </div>
                                                    )}
                                                {product.title && (
                                                    <div
                                                        className="text-ec-body mb-[2px]"
                                                        style={{
                                                            color:
                                                                attributes.titleColor ||
                                                                'var(--color-ec-body)',
                                                            fontSize:
                                                                attributes.titleFontSize
                                                                    ? `${attributes.titleFontSize}px`
                                                                    : '16px',
                                                            fontWeight:
                                                                attributes.titleFontWeight ||
                                                                '500',
                                                            textTransform:
                                                                attributes.titleTextTransform ||
                                                                'none',
                                                            fontStyle:
                                                                attributes.titleStyle ||
                                                                'normal',
                                                            textDecoration:
                                                                attributes.titleDecoration ||
                                                                'none',
                                                            lineHeight:
                                                                attributes.titleLineHeight
                                                                    ? `${attributes.titleLineHeight}px`
                                                                    : '20px',
                                                            letterSpacing:
                                                                attributes.titleSpacing
                                                                    ? `${attributes.titleSpacing}px`
                                                                    : '0px',
                                                        }}
                                                    >
                                                        {product.title}
                                                    </div>
                                                )}

                                                <div className="flex items-center mt-4">
                                                    <div className='easycommerce-product-price-wrap mt-3 flex flex-col gap-4 items-start'>
                                                    <div className="flex items-center gap-3 flex-wrap">
                                                        {product.formatted_sale_price > 0 ? (
                                                            <>
                                                                <span
                                                                    className="text-[#120350] text-base font-inter font-semibold leading-8 mr-3"
                                                                    style={{
                                                                        color: attributes.priceColor || "var(--color-ec-body)",
                                                                        fontSize: attributes.priceFontSize ? `${attributes.priceFontSize}px` : "16px",
                                                                        fontWeight: attributes.priceFontWeight || "500",
                                                                        textTransform: attributes.priceTextTransform || "none",
                                                                        fontStyle: attributes.priceStyle || "normal",
                                                                        textDecoration: attributes.priceDecoration || "none",
                                                                        lineHeight: attributes.priceLineHeight ? `${attributes.priceLineHeight}px` : "20px",
                                                                        letterSpacing: attributes.priceSpacing ? `${attributes.priceSpacing}px` : "0px",
                                                                    }}
                                                                >
                                                                    {product.sale_price}
                                                                </span>
                                                                <del className="text-ec-placeholder font-inter font-normal text-base leading-[26px]">
                                                                    {product.price}
                                                                </del>
                                                            </>
                                                        ) : (
                                                            <span
                                                                className="text-[#120350] text-base font-inter font-semibold leading-8"
                                                                style={{
                                                                    color: attributes.priceColor || "var(--color-ec-body)",
                                                                    fontSize: attributes.priceFontSize ? `${attributes.priceFontSize}px` : "16px",
                                                                    fontWeight: attributes.priceFontWeight || "500",
                                                                    textTransform: attributes.priceTextTransform || "none",
                                                                    fontStyle: attributes.priceStyle || "normal",
                                                                    textDecoration: attributes.priceDecoration || "none",
                                                                    lineHeight: attributes.priceLineHeight ? `${attributes.priceLineHeight}px` : "20px",
                                                                    letterSpacing: attributes.priceSpacing ? `${attributes.priceSpacing}px` : "0px",
                                                                }}
                                                            >
                                                                {product.price}
                                                            </span>
                                                        )}
                                                    </div>

                                                        <button
                                                            href={product.permalink}
                                                            className="flex items-center px-5 py-[7px] easycommerce-button-margin easycommerce-add-to-cart-shop rounded-md hover:!bg-ec-primary transition-all ease-in-out duration-500 gap-1 font-normal"
                                                            style={{
                                                                backgroundColor:
                                                                    attributes.cartButtonBgColor ||
                                                                    'var(--color-ec-accent)',
                                                                color:
                                                                    attributes.cartButtonColor ||
                                                                    'var(--color-ec-primary)',
                                                                fontSize:
                                                                    attributes.cartButtonFontSize
                                                                        ? `${attributes.cartButtonFontSize}px`
                                                                        : '16px',
                                                                fontWeight:
                                                                    attributes.cartButtonFontWeight ||
                                                                    '500',
                                                                textTransform:
                                                                    attributes.cartButtonTextTransform ||
                                                                    'none',
                                                                fontStyle:
                                                                    attributes.cartButtonStyle ||
                                                                    'normal',
                                                                textDecoration:
                                                                    attributes.cartButtonDecoration ||
                                                                    'none',
                                                                lineHeight:
                                                                    attributes.cartButtonLineHeight
                                                                        ? `${attributes.cartButtonLineHeight}px`
                                                                        : '20px',
                                                                letterSpacing:
                                                                    attributes.cartButtonSpacing
                                                                        ? `${attributes.cartButtonSpacing}px`
                                                                        : '0px',
                                                            }}
                                                        >
                                                            <svg
                                                                class="w-5 h-5"
                                                                data-slot="icon"
                                                                fill="none"
                                                                stroke-width="1.5"
                                                                stroke="currentColor"
                                                                viewBox="0 0 24 24"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                aria-hidden="true"
                                                            >
                                                                <path
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                                                                ></path>
                                                            </svg>
                                                            Add To Cart
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No products found.</p>
                            ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Edit;
